export default __webpack_public_path__ + "static/media/btn-color-se_se@3x.6b12c7bb.png";